import React, { FC } from 'react';
import { Box, Table, TableBody, TableCell, TableHead, TableRow, Typography } from '@mui/material';
import { IBulkUpdateRowError } from '../../../utils/bulkUpdateValidation';

const MAX_VISIBLE_ERRORS = 100;

type Props = {
  errors: IBulkUpdateRowError[];
};

const BulkUpdateErrorTable: FC<Props> = ({ errors }) => {
  const visibleErrors = errors.slice(0, MAX_VISIBLE_ERRORS);

  return (
    <Box>
      <Box sx={{ maxHeight: 260, overflowY: 'auto', border: '1px solid #eee', borderRadius: 1 }}>
        <Table size="small" stickyHeader aria-label="bulk update validation errors">
          <TableHead>
            <TableRow>
              <TableCell sx={{ width: 80 }}>Row</TableCell>
              <TableCell sx={{ width: 140 }}>Column</TableCell>
              <TableCell>Error</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {visibleErrors.map((error) => (
              <TableRow key={`${error.row}-${error.column}-${error.message}`}>
                <TableCell>{error.row}</TableCell>
                <TableCell>{error.column}</TableCell>
                <TableCell>{error.message}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </Box>
      {errors.length > visibleErrors.length ? (
        <Typography variant="caption" color="text.secondary">
          Showing the first {MAX_VISIBLE_ERRORS} of {errors.length} errors.
        </Typography>
      ) : null}
    </Box>
  );
};

export default BulkUpdateErrorTable;
